module.exports = __webpack_public_path__ + "img/green-arrow.3a91882b.png";